import { navigateTo } from '../../../history';

export default function navigate(currentPathname, url) {
    if (currentPathname !== url) {
        navigateTo(url);
    }
}
